import { Injectable, inject } from '@angular/core';
import {
    IRelatedProductsCallback,
    IRelatedProductsOptions,
    RelatedProductsService
} from '@df/catalog-ui/related-products/related-products.service';
import { KlevuSearchService } from '@df/module-klevu-search/klevu-search.service';
import { surviveTreeShaking } from '@df/ng/survive-tree-shaking';
import take from 'lodash-es/take';
import { KlevuSearch } from './klevu-interfaces';

@Injectable({
    providedIn: 'root'
})
export class KlevuRecommendationsEngine {
    private klevuSearchService = inject(KlevuSearchService);

    get(
        _ids: number[],
        callback: IRelatedProductsCallback,
        engineOptions: KlevuSearch.IRecommendationsOptions,
        _options: IRelatedProductsOptions
    ): void {
        if (engineOptions?.klevuTypeId) {
            this.klevuSearchService
                .loadRecommendationsProducts(engineOptions)
                .then(products => {
                    const productsIds = (engineOptions.klevuLimit ? take(products, engineOptions.klevuLimit) : products).map(i => i.id);

                    callback(productsIds);
                })
                .catch(() => {
                    callback([]);
                });
        } else {
            callback([]);
        }
    }
}
surviveTreeShaking(KlevuRecommendationsEngine);
RelatedProductsService.registerEngine(KlevuSearch.recommendationsEngineId, KlevuRecommendationsEngine);
